import styled from "@emotion/styled"
import { TabContext, TabList, TabPanel } from "@material-ui/lab"
import { Box, List, Tab } from "@mui/material"
import { DlspTaskListItem } from "./DlspTaskListItem"
import { useState } from "react"
import { useEffect } from "react"

const StyledTabPanel = styled(TabPanel)(({theme}) => {
    return ({
        [theme.breakpoints.down('md')]: {
            "&.MuiTabPanel-root": {
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    })
})

export default function DlspSuburbTaskListTabs({taskList, assignee, selectedTab}) {
    const [tabValue, setTabValue] = useState(0)
    const [filteredTabData, setFilteredTabData] = useState({})

    useEffect(() => {
        const theTabData = {
            'Desktop': {
                inspections: taskList.filter(t => t.status === 'Desktop'),
                loading: true
            },
            'Priority QA / Too Hard': {
                inspections: taskList.filter(t => t.desktopInspTooHard === true),
                loading: true
            },
            'Desktop QA': {
                inspections: taskList.filter(t => t.status === 'Desktop QA'),
                loading: true
            },
            'Field': {
                inspections: taskList.filter(t => t.status === 'Field'),
                loading: true
            },
            'Field QA': {
                inspections: taskList.filter(t => t.status === 'Field QA'),
                loading: true
            },
            'Remedial': {
                inspections: taskList.filter(t => t.status === 'Remedial'),
                loading: true
            },
            'FSP': {
                inspections: taskList.filter(t => t.status === 'FSP'),
                loading: true
            },
            'Eliminated': {
                inspections: taskList.filter(t => t.status === 'Eliminated'),
                loading: true
            },
        }
        setFilteredTabData(theTabData)

        const nameOfFirstTabWithContent = Object.keys(theTabData).find((tabName) => theTabData[tabName].inspections.length > 0)
        const nameOfSelectedTab = selectedTab ? selectedTab : nameOfFirstTabWithContent
        const inxedOfFirstTabWithContent = nameOfSelectedTab ? Object.keys(theTabData).indexOf(nameOfSelectedTab) : 0
        setTabValue(inxedOfFirstTabWithContent.toString())

    }, [taskList, selectedTab])

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
    }

    return (
        <Box>
            <TabContext value={tabValue}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabChange} indicatorColor="primary">
                    {
                        Object.entries(filteredTabData).map(([tabName, {inspections, loading}], index) => {
                            const tabLabel = `${tabName} (${inspections?.length})`
                            return (
                                <Tab key={tabName} label={tabLabel} value={index.toString()} disabled={!inspections?.length} />
                            )
                        })
                    }
                    </TabList>
                </Box>
                {
                    Object.entries(filteredTabData).map(([tabName, {inspections, loading}], index) => {
                        return (
                            <StyledTabPanel key={tabName} value={index.toString()}>
                                <List>
                                {
                                    inspections?.map((t, index) => {
                                        return (
                                            <DlspTaskListItem key={t.icpNumber || index} task={t} assignee={assignee} />
                                        )
                                    })
                                }
                                </List>
                            </StyledTabPanel>
                        )
                    })
                }
            </TabContext>

        </Box>
    )
}